import React, { useEffect, useState } from "react";
import img1 from "../../../assets/hotel-thumbnail.jpeg";
import  button from "../../../assets/Button.png";
import {useNavigate} from "react-router-dom";
import { toast } from'react-toastify';
import axios from 'axios';
import { baseUrl } from '../../../common/baseUrl';
import bykeLogo from "../../../assets/logoBykeSignature.jpeg"
import { getImageUrl, peekImageUrl, prefetchImage } from '../../../common/imageUrl';


export default function Card(props) {

  const profilePhoto = props.data.hotel_details.profile_photo;
  const landingPhoto = props.data.hotel_details.landing_photo;

  // Seeded from the cache so a photo we already have paints on the first
  // render rather than after the placeholder.
  const [imageUrl, setImageUrl] = useState(() => peekImageUrl(profilePhoto) || "");



  useEffect(() => {
    let isCancelled = false;

    getImageUrl(profilePhoto)
      .then((url) => {
        if (!isCancelled && url) {
          setImageUrl(url);
        }
      })
      .catch((error) => {
        console.error("Error fetching image:", error);
      });

    return () => {
      isCancelled = true;
    };
  }, [profilePhoto]);

  // The hero photo of the screen behind this card. Warming it here means the
  // hotel screen paints its real image instead of the default one.
  useEffect(() => {
    if (props.status !== "ONGOING" && props.status !== "UPCOMING") {
      return;
    }

    prefetchImage(landingPhoto);
  }, [landingPhoto, props.status]);



  const navigate = useNavigate();

  const goToBooking = () => {
    if(props.status!=="ONGOING" && props.status!=="UPCOMING"){
      return;
    }
    navigate(`/bookings/${props.bookingId}`,{state : {
      hotelId : props.hotelId,
      hotelName : props.hotelName,
      hotelAddress : props.hotelAddress,
      checkInDate : props.checkInDate,
      checkOutDate : props.checkOutDate,
      status : props.status,
      activeTab : props.activeTab,
      booking_code : props.booking_code,
      landing_photo : landingPhoto
    }});
  };

  // The booking used to be fetched here before navigating, but the response was
  // discarded and the navigation happened either way, so it only ever delayed
  // the tap. The hotel screen fetches the booking itself.
  const handleClick = () => {
    goToBooking();
  }
 

  const formatDate = (dateString) => {
    // Create a new Date object from the date string
    const date = new Date(dateString);
  
    // Array of month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
    "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  
    // Get the month, day, and year from the Date object
    const month = monthNames[date.getMonth()]; // getMonth() returns the month index (0-11)
    const day = date.getDate(); // getDate() returns the day of the month (1-31)
    const year = date.getFullYear(); // getFullYear() returns the full year (e.g., 2024)
  
    // Return the formatted string with the year included
    return `${month} ${day}, ${year}`;
  };

  const formatMonth = (dateString)=>{
    // Create a new Date object from the date string
    const date = new Date(dateString);

    // Array of month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
    "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
  
    // Get the month, day, and year from the Date object
    const month = monthNames[date.getMonth()]; // getMonth() returns the month index (0-11)
    const day = date.getDate(); // getDate() returns the day of the month (1-31)
  
  
    // Return the formatted string with the year included
    return `${month} ${day}`;

  }
  
  const checkIn = formatDate(props.checkInDate);
  const checkOut = formatDate(props.checkOutDate);

  const checkInMonth = formatMonth(props.checkInDate);
  const checkOutMonth = formatMonth(props.checkOutDate);

  // console.log("Props")
  const renderArrow = () => {
    if (props.status === "PAST") {
      // Don't show arrow if the status is "PAST"
      return null;
    } else if (props.status === "ONGOING") {
      // Show arrow if the status is "ONGOING"
      return (
        <div className='booking-card-button'>
          <img src={button} alt="arrow" />
        </div>
      );
    } 
    else if (props.status === "UPCOMING") {
      return(  
        <div className='booking-card-button'>
          <img src={button} alt="arrow" />
        </div>
      )
    } 
    else {
      // Default: don't show arrow
      return null;
    }
  };
  
  return (
    <>
      <div className='booking-card'  onClick={() => {
        // if (
        //   (props.status === "UPCOMING" && props.guestDetailsId === props.userId) ||
        //   props.status === "ONGOING"
        // ) {
          handleClick();
        // }
          
      }} 
     >
        <div className='booking-card-date'>
          <p>
          {checkIn}
          </p>
        </div>
        <div className='booking-card-main'>
          <div className='booking-card-side1'>
            <div className='booking-card-header'>
              <h4>
                Stay
              </h4>
            </div>
            <div className='booking-card-para'>
              <p style={{fontSize : '13px',marginTop:'4px'}}>
                @{props.hotelName}
              </p>
              <p style={{fontSize : '11px',marginTop:'4px'}}>
                {checkInMonth} -{checkOutMonth} 
                <span style={{color: 'black'}}>
                  •</span>{props.people} people
              </p>
              <p style={{color : "#ACB8C2",fontSize:'11px',marginTop:'4px'}}>
              {props.hotelAddress}  
              </p>
              {props.status==="UPCOMING" && 
              <div className="booking-card-badge">
                  <span>
                    Complete Web Check-In
                  </span>
              </div>
              }
            </div>
          </div>
        <div className='booking-card-side2'>
          <div className='booking-card-img'>
           <img
              src={imageUrl || img1}
              alt={props.hotelName}
              style={{ objectFit: "cover" }}
            />
          </div>
          {/*  Button Icon */}
          {renderArrow()}
        
        </div>
      </div>
      </div>
    </>
  )
}